@if (tipsVises()) {
  <ropert (vedSkjul)="skjulTips()" blokk="true" data-testid="start-moete-transkripsjon-tips">
    <span (click)="startTranskripsjon()" class="melding" data-testid="start-opptak-knapp">
      <mat-icon inline="true" aria-hidden="true">mic</mat-icon>
      <span>
        <a>{{ 'Start lydopptak av møtet,'|translate }}</a>
        {{ 'lydopptaket vil bli brukt til å lage et forslag til protokoll'|translate }}
      </span>
    </span>
  </ropert>
}
